import * as THREE from 'three';
import { getTemperatureColor } from '../../../data/global';
import { CustomText3D } from "../../_shared/CustomText3D";
import { Suspense, useRef } from "react";
import * as global from '../../../data/global';
import { humidityLayoutColor, isHumidityLayoutSensor } from './humidity3d';

const raycaster = new THREE.Raycaster();

function isPointOutsideCircle(pointX, pointY, circleX, circleY, radius) {
    let distance = Math.sqrt(
        Math.pow(pointX - circleX, 2) + Math.pow(pointY - circleY, 2)
    );
    return distance > radius;
}

export const SensorNew = ({ layoutSensor, position }) => {
    const sensorRef = useRef(null);
    const handleThermo = async (showThermo, binMeshes, binBoundingBoxes) => {
        if (isHumidityLayoutSensor(layoutSensor)) return;
        if (showThermo) {
            if (sensorRef && sensorRef.current) {
                const particlePositions = [];

                let siteWorld = new THREE.Vector3(sensorRef.current.parent.parent.parent.position.x, sensorRef.current.parent.parent.parent.position.y, sensorRef.current.parent.parent.parent.position.z);
                let binWorld = new THREE.Vector3(sensorRef.current.parent.parent.position.x, sensorRef.current.parent.parent.position.y, sensorRef.current.parent.parent.position.z);
                let sensorWorld = new THREE.Vector3(sensorRef.current.position.x, sensorRef.current.position.y, sensorRef.current.position.z);
                let position = sensorRef.current.children[0].position.clone().add(sensorWorld.clone()).add(binWorld.clone().add(siteWorld.clone()));

                const particleGeometry = new THREE.BufferGeometry();

                let binBoundingBox = binBoundingBoxes.filter(x => x.binId === sensorRef.current.children[0].meshProps.binId);
                let boundingBox = null;
                let binMesh = binMeshes.filter(x => x.binId === sensorRef.current.children[0].meshProps.binId);
                if (binBoundingBox.length > 0) {
                    boundingBox = binBoundingBox[0];
                }
                else {
                    boundingBox = new THREE.Box3().setFromObject(sensorRef.current.parent.parent);
                }

                const binCenter = new THREE.Vector3();
                boundingBox.getCenter(binCenter);
                const binHeight = boundingBox.max.y;
                const radius = sensorRef.current.parent.parent.width / 2;
                let iterations = Math.round(radius * 0.48);
                if (iterations < 18) {
                    iterations = 18;
                }

                for (let s = 1; s <= iterations; s++) {
                    const sphereCenter = new THREE.Vector3(position.x, position.y, position.z);
                    const sphereGeometry = new THREE.SphereGeometry(s, 20 + s * 2, 20 + s * 2);
                    const gposition = sphereGeometry.attributes.position;
                    const vector = new THREE.Vector3();

                    for (let i = 0, l = gposition.count; i < l; i++) {
                        vector.fromBufferAttribute(gposition, i);

                        if (vector.x === 0 &&
                            vector.z === 0) {
                            continue;
                        }

                        vector.applyMatrix4(sensorRef.current.parent.parent.parent.parent.parent.matrixWorld);
                        vector.add(sphereCenter.clone());

                        //vector.x = Math.round(vector.x * 10) / 10;
                        //vector.y = Math.round(vector.y * 10) / 10;
                        //vector.z = Math.round(vector.z * 10) / 10;

                        if (vector.y > -1.5 && vector.y < binHeight) {
                            let isOutsideCircle = isPointOutsideCircle(vector.x, vector.z, binCenter.x, binCenter.z, radius);
                            if (!isOutsideCircle) {
                                if (binMesh.length > 0) {
                                    //global.isPointYInsideMeshY(vector, binMesh[0])
                                    raycaster.set(vector, new THREE.Vector3(0, 1, 0));
                                    const intersects = raycaster.intersectObject(binMesh[0]);

                                    if (intersects.length > 0) {
                                        particlePositions.push(vector.x, vector.y, vector.z);
                                    }
                                }
                                else {
                                   particlePositions.push(vector.x, vector.y, vector.z);
                                }
                            }
                        }
                    }
                }

                const particleMaterial = new THREE.PointsMaterial({
                    color: sensorRef.current.children[0].meshProps.material.color,
                    //emissiveIntensity: 0.25,
                    //intensity: 1,
                    //emissive: p.meshProps.material.color,
                    size: 0.05,
                    transparent: true,
                    opacity: 0.1,
                    //opacity: 1,
                    //map: smokeTexture,
                    //side: THREE.DoubleSide,
                });


                particleGeometry.setAttribute('position', new THREE.Float32BufferAttribute(particlePositions, 3));
                const particleSystem = new THREE.Points(particleGeometry, particleMaterial);
                particleSystem.isParticle = true;
                sensorRef.current.parent.parent.parent.parent.parent.add(particleSystem);
                //return particleSystem;
                //sensorRef.parent.parent.parent.parent.parent.parent.add(particleSystem);



                //const sphereCenter = new THREE.Vector3(position.x, position.y, position.z);
                //const sphereGeometry = new THREE.SphereGeometry(3, 32, 32);
                //let mesh = new THREE.Mesh(sphereGeometry, particleMaterial);
                //mesh.isParticle = true;
                //sensorRef.current.add(mesh);
            }
        }
        else {
            for (let i = 0; i < sensorRef.current.parent.parent.parent.parent.parent.children.length; i++) {
                const child = sensorRef.current.parent.parent.parent.parent.parent.children[i];
                if (child.isParticle) {
                    child.parent.remove(child);
                    i--;
                }
            }
        }
    }

    const color = isHumidityLayoutSensor(layoutSensor)
        ? humidityLayoutColor(layoutSensor)
        : getTemperatureColor(layoutSensor.sensorValueString);
    let temperature = layoutSensor.sensorValueString ?? "";
    
    // Check if this is an invalid temperature (-E- or -O-)
    const isInvalidTemperature = temperature === "-E-" || temperature === "-O-" || temperature === "E" || temperature === "";
    const isHumidity = isHumidityLayoutSensor(layoutSensor);
    
    if (temperature.length === 2) {
        temperature = ` ${temperature}`;
    }
    else if (temperature.length === 1) {
        temperature = `  ${temperature}`;
    }
    
    // In light mode, invalid temperatures should be visible with same color as bin name labels
    let materialColor = !color ? new THREE.Color(0.8, 0.8, 0.8) : color;
    let materialOpacity = !color ? 0.01 : 1;
    let materialTransparent = true;
    
    if (isHumidity) {
        if (temperature === "Off" || temperature === "CON") {
            materialColor = new THREE.Color(0xff0000);
            materialOpacity = 1.0;
            materialTransparent = false;
        } else if (temperature === "-O-") {
            materialColor = new THREE.Color(0xffffff);
            materialOpacity = 1.0;
            materialTransparent = false;
        } else if (isInvalidTemperature) {
            if (global.gw.theme === 'light') {
                materialColor = new THREE.Color(0xb4b4b4);
                materialOpacity = 1.0;
                materialTransparent = false;
            } else {
                materialOpacity = 0.0025;
                materialTransparent = true;
            }
        } else {
            materialColor = color;
            materialOpacity = 1;
            materialTransparent = false;
        }
    } else if (isInvalidTemperature) {
        if (global.gw.theme === 'light') {
            materialColor = new THREE.Color(0xb4b4b4);
            materialOpacity = 1.0;
            materialTransparent = false;
        } else {
            // In dark mode, invalid temperatures should have very low opacity
            materialOpacity = 0.0025;
            materialTransparent = true;
        }
    }
    
    const isLight = global.gw.theme === 'light';

    return (
        <group
            ref={sensorRef}
            position={[position.x, position.y, position.z]}
            rotation={[0, 0, 0]}
        >
            <CustomText3D
                handleThermo={handleThermo}
                //color={color}
                scale={0.05}
                side={THREE.FrontSide}
                position={[0, 0, 0]}
                meshProps={{
                    binId: layoutSensor.binId,
                    cableId: layoutSensor.cableId,
                    sensorId: layoutSensor.sensorId,
                    isSensor: true,
                    isHumiditySensor: isHumidity,
                    material: isHumidity
                        ? new THREE.MeshBasicMaterial({
                            color: materialColor,
                            side: THREE.FrontSide,
                            toneMapped: false,
                            transparent: materialTransparent,
                            opacity: materialOpacity,
                        })
                        : new THREE.MeshStandardMaterial({
                            color: materialColor,
                            emissive: isLight ? "#000000" : materialColor,
                            side: THREE.FrontSide,
                            toneMapped: isLight,
                            envMapIntensity: 1,
                            metalness: 0.0,
                            transparent: materialTransparent,
                            opacity: materialOpacity,
                        }),
                }}
            >
                {temperature}
            </CustomText3D>
        </group>
    );
}
export default SensorNew;